import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import {
  Activity,
  AlertCircle,
  Instagram,
  Star,
} from "feather-icons-react/build/IconComponents";
import Chart from "react-apexcharts";
import { Link, useLocation, useNavigate } from "react-router-dom/dist";
import { ArrowRight } from "react-feather";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Spin } from "antd";
import { ROLL_CALL_API_BASE_URL } from "../RollCall/RollCallConfig/RollCallConfig";
const KpiDashboard = () => {
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [perm, setPerm] = useState({
    Read: false,
    Write: false,
    Delete: false,
    Export: false,
  });
  console.log(perm);
  const [kpiCountData, setKpiCountData] = useState(null);
  const [kpiCountLoading, setKpiCountLoading] = useState(false);
  const [kpiChartSeries, setKpiChartSeries] = useState([]);
  const [kpiChartCategories, setKpiChartCategories] = useState([]);
  const [isKpiChartLoading, setIsKpiChartLoading] = useState(false);
  const [topBranches, setTopBranches] = useState([]);
  const [leastBranches, setLeastBranches] = useState([]);
  const [topLoading, setTopLoading] = useState(false);
  const [leastLoading, setLeastLoading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const stored = sessionStorage.getItem("rollcall-permissions");
    if (!stored) return;

    const map = JSON.parse(stored);
    const path = location.pathname.slice(1);
    const perms = map[path];
    if (!perms) {
      navigate("/rollcall/dashboard");
      return;
    }
    if (perms) {
      setPerm({
        Read: perms.canRead,
        Write: perms.canWrite,
        Delete: perms.canDelete,
        Export: perms.canExport,
      });
    }
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);
  console.log(leastBranches, leastLoading);
  const fetchKpiData = async () => {
    if (!superIdData && !tokenData) return;
    setKpiCountLoading(true);

    try {
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/kpi/getKPIadminCounts?SuperId=${superIdData}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenData}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch KPI data");
      }

      const result = await response.json();

      // Store only useful part
      setKpiCountData(result?.ResultData?.[0] || null);

      console.log("KPI API Response:", result);
    } catch (err) {
      console.error("KPI Error:", err.message);
    } finally {
      setKpiCountLoading(false);
    }
  };

  const fetchKpiChartData = async () => {
    if (!superIdData && !tokenData) return;

    setIsKpiChartLoading(true);

    try {
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/kpi/getKPIadmingraph?SuperId=${superIdData}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenData}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch KPI chart data");
      }

      const result = await response.json();

      const monthData = result?.monthdata || {};

      const categories = Object.keys(monthData); // ["Nov", "Dec", ...]
      const data = Object.values(monthData); // [0, 0, ...]

      setKpiChartCategories(categories);
      setKpiChartSeries([
        {
          name: "KPI",
          data: data,
        },
      ]);

      console.log("Chart Categories:", categories);
      console.log("Chart Data:", data);
    } catch (err) {
      console.error("Chart Error:", err.message);
    } finally {
      setIsKpiChartLoading(false);
    }
  };

  const fetchBranches = async (order, setData, setLoading) => {
    if (!superIdData && !tokenData) return;

    setLoading(true);

    try {
      const res = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/kpi/getKPITopPerformedBranches?SuperId=${superIdData}&Order=${order}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenData}`,
          },
        },
      );

      const data = await res.json();

      if (data.status) {
        setData(data.ResultData || []);
      } else {
        console.log(data.message || "Failed to fetch data");
      }
    } catch (err) {
      console.log("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchKpiData();
    fetchKpiChartData();
    fetchBranches(1, setTopBranches, setTopLoading);
    fetchBranches(0, setLeastBranches, setLeastLoading);
  }, [superIdData, tokenData]);

  const chartOptions = {
    chart: {
      type: "bar",
      height: 320,
      stacked: true,
      zoom: { enabled: true },
    },
    colors: ["#28C76F"],
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 4,
        borderRadiusApplication: "end",
        borderRadiusWhenStacked: "all",
        columnWidth: "30%",
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: kpiChartCategories,
    },
    yaxis: {
      min: 0,
    },
    legend: { show: false },
    fill: { opacity: 1 },
  };

  const branches = [
    { rank: 10, location: "Uppal", camps: 8, patients: 1250, kpi: 640 },
    { rank: 9, location: "Dilsukhnagar", camps: 9, patients: 1400, kpi: 680 },
    { rank: 8, location: "L.B Nagar", camps: 10, patients: 1500, kpi: 720 },
    { rank: 7, location: "Mehdipatnam", camps: 11, patients: 1600, kpi: 750 },
    { rank: 6, location: "RTC X Roads", camps: 12, patients: 1700, kpi: 790 },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="card dash-widget w-100">
                <div className="card-body d-flex align-items-center">
                  <div className="dash-widgetimg">
                    <span>
                      <ImageWithBasePath
                        src="assets/img/icons/diagostic.svg"
                        alt="img"
                      />
                    </span>
                  </div>
                  <div className="dash-widgetcontent">
                    <h5>
                      {kpiCountLoading ? (
                        <Spin size="small" />
                      ) : (
                        <CountUp
                          className="counters"
                          start={0}
                          end={kpiCountData?.TotalCentresCount}
                          duration={3}
                          prefix=""
                        />
                      )}
                    </h5>
                    <p className="mb-0">Total Centers</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="card dash-widget dash1 w-100">
                <div className="card-body d-flex align-items-center">
                  <div className="dash-widgetimg">
                    <span>
                      <ImageWithBasePath
                        src="assets/img/icons/graph.svg"
                        alt="img"
                      />
                    </span>
                  </div>
                  <div className="dash-widgetcontent">
                    <h5>
                      <span className="counters">
                        {kpiCountLoading ? (
                          <Spin size="small" />
                        ) : (
                          <CountUp
                            className="counters"
                            start={0}
                            end={kpiCountData?.OverallKPIRating}
                            duration={3}
                            prefix=""
                          />
                        )}
                      </span>
                    </h5>
                    <p className="mb-0">Overall KPI Rating</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="card dash-widget dash2 w-100">
                <div className="card-body d-flex align-items-center">
                  <div className="dash-widgetimg">
                    <span>
                      <ImageWithBasePath
                        src="assets/img/icons/cash.svg"
                        alt="img"
                      />
                    </span>
                  </div>
                  <div className="dash-widgetcontent">
                    <h5>
                      <span className="counters">
                        {kpiCountLoading ? (
                          <Spin size="small" />
                        ) : (
                          <CountUp
                            className="counters"
                            start={0}
                            end={kpiCountData?.TotalCollection}
                            duration={3}
                            prefix=""
                          />
                        )}
                      </span>
                    </h5>
                    <p className="mb-0">Total Collection </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="card dash-widget dash3 w-100">
                <div className="card-body d-flex align-items-center">
                  <div className="dash-widgetimg">
                    <span>
                      <ImageWithBasePath
                        src="assets/img/icons/diagostic.svg"
                        alt="img"
                      />
                    </span>
                  </div>
                  <div className="dash-widgetcontent">
                    <h5>
                      <span className="counters">
                        {kpiCountLoading ? (
                          <Spin size="small" />
                        ) : (
                          <CountUp
                            className="counters"
                            start={0}
                            end={kpiCountData?.TotalExpenses}
                            duration={3}
                            prefix=""
                          />
                        )}
                      </span>
                    </h5>
                    <p className="mb-0">Total Expenses</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-count">
                <div className="dash-counts">
                  <h4>
                    {kpiCountLoading ? (
                      <Spin size="small" />
                    ) : (
                      <CountUp
                        className="counters"
                        start={0}
                        end={kpiCountData?.Complaints}
                        duration={3}
                        prefix=""
                      />
                    )}
                  </h4>
                  <h5>Raise in Issues</h5>
                </div>
                <div className="dash-imgs">
                  <AlertCircle />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-count das1">
                <div className="dash-counts">
                  <h4>
                    {" "}
                    {kpiCountLoading ? (
                      <Spin size="small" />
                    ) : (
                      <CountUp
                        className="counters"
                        start={0}
                        end={kpiCountData?.InstagramFollowers}
                        duration={3}
                        prefix=""
                      />
                    )}
                  </h4>
                  <h5>Instagram Followers</h5>
                </div>
                <div className="dash-imgs">
                  <Instagram />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-count das2 bg-dark">
                <div className="dash-counts">
                  <h4>
                    {" "}
                    {kpiCountLoading ? (
                      <Spin size="small" />
                    ) : (
                      <CountUp
                        className="counters"
                        start={0}
                        end={kpiCountData?.GoogleAvgRating}
                        duration={3}
                        prefix=""
                      />
                    )}
                  </h4>
                  <h5>Google ratings</h5>
                </div>
                <div className="dash-imgs">
                  <Star />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-count das3">
                <div className="dash-counts">
                  <h4>
                    {kpiCountLoading ? (
                      <Spin size="small" />
                    ) : (
                      <CountUp
                        className="counters"
                        start={0}
                        end={kpiCountData?.Camps}
                        duration={3}
                        prefix=""
                      />
                    )}
                  </h4>
                  <h5>Camps Conducted</h5>
                </div>
                <div className="dash-imgs">
                  <Activity />
                </div>
              </div>
            </div>
          </div>
          {/* Button trigger modal */}

          <div className="row">
            <div className="col-xl-7 col-sm-12 col-12 d-flex">
              <div className="card flex-fill">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h5 className="card-title mb-0">Last 6 Months KPI</h5>
                  <div className="graph-sets">
                    {/* <ul className="mb-0">
                      <li>
                        <span>Sales</span>
                      </li>
                      <li>
                        <span>Purchase</span>
                      </li>
                    </ul> */}
                    <div className="dropdown dropdown-wraper">
                      <button
                        className="btn btn-light btn-sm dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        2025
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <li>
                          <Link to="#" className="dropdown-item">
                            2023
                          </Link>
                        </li>
                        <li>
                          <Link to="#" className="dropdown-item">
                            2022
                          </Link>
                        </li>
                        <li>
                          <Link to="#" className="dropdown-item">
                            2021
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div id="sales_charts" />
                  {isKpiChartLoading ? (
                    <Spin />
                  ) : (
                    <Chart
                      options={chartOptions}
                      series={kpiChartSeries}
                      type="bar"
                      height={220}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-sm-12 col-12 d-flex">
              <div className="card flex-fill default-cover mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title mb-0">
                    Top 5 Branches (Last Month)
                  </h4>
                  <div className="view-all-link">
                    <Link
                      to="#"
                      className="view-all d-flex align-items-center d-none"
                    >
                      View All
                      <span className="ps-2 d-flex align-items-center">
                        <ArrowRight className="feather-16" />
                      </span>
                    </Link>
                  </div>
                </div>
                <div className="card-body pt-0">
                  <div className="table-responsive dataview">
                    <table className="table dashboard-recent-products">
                      <thead className="thead-light">
                        <tr>
                          <th>#</th>
                          <th>Branch</th>
                          <th>Score</th>
                        </tr>
                      </thead>
                      <tbody>
                        {topLoading ? (
                          <tr>
                            <td colSpan="3" className="text-center">
                              <Spin />
                            </td>
                          </tr>
                        ) : topBranches.length === 0 ? (
                          <tr>
                            <td colSpan="3" className="text-center">
                              No data available
                            </td>
                          </tr>
                        ) : (
                          topBranches.map((item, index) => (
                            <tr key={item.BranchCode}>
                              <td>{item.Rank || index + 1}</td>

                              <td className="d-flex align-items-center">
                                <Link className="fw-bold">
                                  {item.BranchName}
                                </Link>
                              </td>
                              <td className="d-flex align-items-center">
                                <Link className="fw-bold">
                                  {item.BranchCode}
                                </Link>
                              </td>

                              <td>{item.Points}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">
                Least Performing Branches (Last Month)
              </h4>
            </div>
            <div className="card-body">
              <div className="table-responsive dataview">
                <table className="table dashboard-expired-products">
                  <thead className="thead-light">
                    <tr>
                      <th>Rank</th>
                      <th>Location</th>
                      <th>No. of Camps</th>
                      <th>No. of Patients</th>
                      <th>KPI Points</th>
                      <th className="no-sort">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {branches.map((item, index) => (
                      <tr key={index}>
                        <td>{item.rank}</td>
                        <td>{item.location}</td>
                        <td>{item.camps}</td>
                        <td>{item.patients}</td>
                        <td>{item.kpi}</td>

                        <td className="action-table-data">
                          <div className="edit-delete-action">
                            <Link className="p-2" to="#">
                              <i className="fa-regular fa-bell"></i>
                            </Link>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KpiDashboard;
